import React, { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import Modal, { ModalBody, ModalFooter } from 'Components/Modal';
import { Button } from 'Components';
import { NotificationManager } from 'Components/Notifications';

import {
  deleteTimeCard,
  openTimeCardDelete,
  clearRedux
} from 'Redux/actions';


const TimeCardDelete = (props) => {
  const dispatch = useDispatch();
  const { callBack } = props;
  const { messages } = useIntl();

  const optionsAction = [{
    id: 'I',
    name: messages['FSM_SETTINGS_TIME_CARD_clockIn']
}, {
    id: 'O',
    name: messages['FSM_SETTINGS_TIME_CARD_clockOut']
},
{
    id: 'BO',
    name: messages['FSM_SETTINGS_TIME_CARD_meakbegin']
},
{
    id: 'BI',
    name: messages['FSM_SETTINGS_TIME_CARD_meakEnd']
}];
  const {
    openDelete,
    timeCardDelete,
    responseDelete,
    loadingDelete
  } = useSelector((state) => state.timeCardsRedux);



  useEffect(() => {
    if (responseDelete === true) {
      NotificationManager.success(
        messages['FSM_SETTINGS_TIME_CARD_delete_success'],
        messages['success'],
        3000,
        null,
        null,
        'Success',
      );
      dispatch(clearRedux("FSM_SETTINGS_TIME_CARD", {
        responseDelete: false
      }));
      handleClose();

    }
  }, [responseDelete]);


  const handleClose = useCallback(() => {
    dispatch(clearRedux("FSM_SETTINGS_TIME_CARD", {
      responseDelete: false
    }));
    callBack();
    dispatch(openTimeCardDelete(false, []));
  });

  return (
    <Modal
      title={messages["FSM_SETTINGS_TIME_CARD_delete_title"]}
      open={openDelete}
      position="right"
      size="small"
      className="modal-top-0"
      headerStyle={{
        top: 0
      }}
      handleClose={handleClose}
    >
      <ModalBody>
        <div style={{ padding: '18px 24px 24px 24px', height: 650 }}>

          <div>
            <p>
              {messages["FSM_SETTINGS_TIME_CARD_delete_detail"]}
            </p>
            <p>
              {messages["FSM_SETTINGS_TIME_CARD_delete_warning"]}
            </p>
          </div>

          <div style={{ padding: 10 }}>
            <ul>
              {
                timeCardDelete
                &&
                timeCardDelete.map((TimeCard, index) => {

                  let action = optionsAction.filter(actions => actions.id === TimeCard?.action)[0].name;

                  return (
                    <li key={index}>
                      <span>{action}</span>
                    </li>
                  )
                })
              }
            </ul>
          </div>

        </div>
      </ModalBody>

      <ModalFooter style={{ boxShadow: "2px 2px 2px 1px rgb(2 0 0 / 94%)" }} >
        <Button
          disabled={loadingDelete}
          onClick={handleClose}
          className="btn-cancel"
        >
          {messages['cancel']}
        </Button>

        <Button
          disabled={loadingDelete}
          onClick={(e) => {
            if (e) e.preventDefault();

            dispatch(deleteTimeCard(timeCardDelete));
          }}
          className="btn-red"
        >
          {messages['delete']}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default TimeCardDelete;